import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M4 27h24a2 2 0 002-2V9a2 2 0 00-2-2H15.5l-1.7-2.5a1 1 0 00-.9-.5H4a2 2 0 00-2 2v19a2 2 0 002 2zM4 6h8.4l1.4 2.1.6.9H28v16H4z"/><path d="M25 11H14.4a2 2 0 00-1.4.6L11.6 13H7a1 1 0 000 2h4.6a2 2 0 001.4-.6l1.4-1.4H25a1 1 0 000-2z"/>';
export var FolderOutlineSVG = function FolderOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FolderOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FolderOutlineSVG);